import * as React from 'react';
import clsx from 'clsx';
import { PlayIcon, PauseIcon } from '@heroicons/react/24/solid';

interface WaveformViewProps {
  containerRef: React.RefObject<HTMLDivElement | null>;
  isPlaying: boolean;
  currentTime: string;
  duration: string;
  onTogglePlay: () => void;
  variant?: 'bubble' | 'minimal';
  className?: string | undefined;
  buttonClassName?: string | undefined;
  textClassName?: string | undefined;
  disabled?: boolean;
}

export const WaveformView: React.FC<WaveformViewProps> = ({
  containerRef,
  isPlaying,
  currentTime,
  duration,
  onTogglePlay,
  variant = 'bubble',
  className,
  buttonClassName,
  textClassName,
  disabled = false,
}) => (
  <div className={clsx('flex w-full items-center gap-3', className)}>
    {/* Play/Pause Button */}
    <button
      type='button'
      onClick={(e) => {
        e.stopPropagation();
        onTogglePlay();
      }}
      disabled={disabled}
      className={clsx(
        'flex shrink-0 items-center justify-center transition-transform hover:scale-105 active:scale-95',
        variant === 'bubble' ? 'size-10' : 'size-8',
        buttonClassName
      )}
      aria-label={isPlaying ? 'Pause' : 'Play'}
    >
      {isPlaying ? <PauseIcon className='size-6' /> : <PlayIcon className='size-6' />}
    </button>

    {/* Waveform Container - Updated to center content */}
    <div className='relative flex h-[40px] flex-1 items-center overflow-hidden'>
      <div ref={containerRef} className='w-full' />
    </div>

    {/* Duration Timer */}
    <span className={clsx('min-w-[40px] text-right font-sans text-12 font-medium', textClassName)}>
      {isPlaying ? currentTime : duration}
    </span>
  </div>
);
